import type { Locale } from '@/types/shared';

export type PageType = 'HOMEPAGE' | 'CATEGORY' | 'PRODUCT' | 'CART' | 'OTHER';
export interface RecommendationContext {
  locale?: Locale;
  type?: PageType;
  data?: string[];
}

export const useDynamicYield = (
  locale: Locale = 'en-GB',
  pageType: PageType = 'OTHER',
  data: string[] = [],
) => {
  const lng = locale?.replace('-', '_');

  const recommendationContext = {
    type: pageType,
    data,
    lng,
  };

  return { recommendationContext };
};
